import bService from './base-api'
import { CONTRACT_MANAGER_URL } from '../configs/service-url'

const info = async () => {
  const url = `${CONTRACT_MANAGER_URL.SETTING}/general`
  const result = await bService.get(url)

  return result
}

const update = async (settingDetail) => {
  const url = `${CONTRACT_MANAGER_URL.SETTING}/general`
  const result = await bService.put(url, settingDetail)

  return result
}

export default {
  info,
  update
}
